module.exports = __webpack_public_path__ + "media/images/browsers/blackberry-917fc6be0f1b4ae8acab1f9a002f262d.svg";